<script setup lang="ts">
// @todo(g@hexdigital.com): improve this file when working on f/e, types + data
import { computed, type Component } from 'vue';
import { type CmsIconName } from '@pkg/cms-icons';
import type { Button } from '@pkg/sanity-utils/types/button';

const props = defineProps<{
  block?: {
    pretitle?: string,
    title?: string,
    button?: Button,
    items: Array<{
      icon: CmsIconName,
      prefix?: string,
      stat?: string,
      suffix?: string,
      context?: string,
      content?: string,
    }>,

  },
  config: {
    innerComponent?: Component
  },
}>();

const data = computed(() => ({
  pretitle: props.block?.pretitle,
  title: props.block?.title,
  button: props.block?.button || undefined,
  items: props.block?.items
}));

</script>

<template>
  <component :is="props.config?.innerComponent" v-bind="data"/>
</template>
